const Productos = {
  CAFE: 1,
  CACAO: 2,
  MIEL: 3,
  PIMIENTA: 4,
};

export { Productos };
